import { render } from "./pegawai-list-odata.vue?vue&type=template&id=5712d6ae"
import script from "./pegawai-list-odata.vue?vue&type=script&lang=js"
export * from "./pegawai-list-odata.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__